export const paymentReturnLink = (environment, projectId, status, search = "") => {
	if (environment?.firebaseConfig?.projectId !== projectId) return null;
	let scheme;
	if (environment.key === "development" && projectId === "scervmvp-dev") scheme = "scerv-qa";
	if (environment.key === "testing" && projectId === "scervmvp-testing") scheme = "scerv-testing";
	if (environment.key === "production" && projectId === "scervmvp") scheme = "scerv";
	if (!scheme || !["success", "cancel"].includes(status)) return null;
	const link = `${scheme}://payment-${status}`;
	const orderId = status === "success" ? new URLSearchParams(search).get("orderId") : null;
	return orderId ? `${link}?${new URLSearchParams({ orderId })}` : link;
};
